const suits = ['clover', 'spade', 'diamond', 'heart'] as const;
const ranks = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'A', 'J', 'Q', 'K'] as const;

export { suits, ranks };
